import * as React from "react";

const SvgIcnQuestionnairesBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M15 4a1 1 0 011 1v2.212l-5.887 5.914.05 4.249h4.158L16 15.695V19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10zm-6 9H7v3h2v-3zm9.36-5.37l.091.08 1.27 1.275a1 1 0 01.004 1.407L14.207 16h-2.755l-.034-2.65 5.616-5.639a1 1 0 011.327-.08zm-.617.787l-5.32 5.342.016 1.24h1.349l5.224-5.308-1.27-1.274zM12 7H7v3h5V7z"
        />
    </svg>
);

export default SvgIcnQuestionnairesBold;
